import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';

import * as FileProcessApi from '../../../api/interactTemplateFileProcess.js';
import { Button as CmpButton } from '../../../components/Button';
import ExportConnectionsModal from './exportConnectionsModal';

// Seconds are part of the name: a backup and a later export in the same minute must not become "(1)" copies.
export const connectionsFileName = (environmentName, suffix = '') =>
  `connections-${environmentName || 'environment'}${suffix}-${format(new Date(), 'yyyyMMdd-HHmmss')}.json`;

export default function ConnectionsHeaderButtons({ groupId, templateEnvironment, environmentName, isFirstEnvironment, hasCrudAccess, isVirtual, files }) {
  const navigate = useNavigate();
  const [exportOpen, setExportOpen] = useState(false);

  // Connections of a remote group live on the remote hub, which these endpoints cannot reach.
  if (!templateEnvironment || isVirtual)
    return null;

  const exportConnections = (fileNames) =>
    FileProcessApi.exportConnections(templateEnvironment.id, connectionsFileName(environmentName), fileNames);

  return (
    <div className="flex gap-2">
      <CmpButton id="export-connections" variant={CmpButton.variants.secondary} onClick={() => setExportOpen(true)}>
        Export connections
      </CmpButton>
      {isFirstEnvironment && hasCrudAccess && (
        <CmpButton id="import-connections" variant={CmpButton.variants.primary}
          onClick={() => navigate(`/templates/connections/import/${groupId}/${templateEnvironment.id}`)}>
          Import connections
        </CmpButton>
      )}
      <ExportConnectionsModal open={exportOpen} onClose={() => setExportOpen(false)} onExport={exportConnections}
        environmentName={environmentName} files={files} />
    </div>
  );
}
